export default "__VITE_ASSET__CilchjsR__"